import { ThinContentDto } from '@app/modules/content-ai/content-ai.types';
import { contentAiListContent } from '@mi-front/api-v2';
import { useIntl } from 'react-intl';
import { Page } from '../../../../components/page/Page';
import { ListingView } from '../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../core/reports/types';
import { ContentAiIcon } from '../../ContentAiIcon';
import { ContentsList } from './ContentsList';

export function ContentsListPage() {
  const { $t } = useIntl();

  return (
    <Page
      htmlTitle={$t({
        id: 'contentAi.contentsList.title',
        defaultMessage: 'Content AI - Contenidos',
      })}
    >
      <Page.Header
        icon={<ContentAiIcon />}
        title={$t({
          id: 'contentAi.title',
          defaultMessage: 'Content AI',
        })}
      />
      <ListingView<ListingType<Record<string, never>, ThinContentDto>>
        reportFn={async (values) => {
          const response = await contentAiListContent({
            page: values.pageIndex,
            size: values.pageSize,
          });

          return {
            results: response.results ?? [],
            metadata: {
              page: response.metadata.page,
              pageIndex: response.metadata.page,
              pagesCount: response.metadata.pagesCount,
              showCount: response.metadata.pageSize,
              totalCount: response.metadata.totalCount,
            },
          };
        }}
        Result={ContentsList}
        showEmptyResult
      />
    </Page>
  );
}
